var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FastOrdersCreateAdmin',{attrs:{"FO":_vm.FO},on:{"saveFastOrders":_vm.saveFastOrders}})
}
var staticRenderFns = []

export { render, staticRenderFns }